const DotsMenu = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="22" height="22" rx="11" fill="#F4F5F6" />
    <path
      d="M16.96 11C16.96 11.2533 16.7547 11.4586 16.5015 11.4586C16.2483 11.4586 16.043 11.2533 16.043 11C16.043 10.7468 16.2483 10.5415 16.5015 10.5415C16.7547 10.5415 16.96 10.7468 16.96 11"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.46 11C11.46 11.2533 11.2547 11.4586 11.0015 11.4586C10.7483 11.4586 10.543 11.2533 10.543 11C10.543 10.7468 10.7483 10.5415 11.0015 10.5415C11.2547 10.5415 11.46 10.7468 11.46 11"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.95611 11C5.95611 11.2533 5.75082 11.4586 5.49759 11.4586C5.24435 11.4586 5.03906 11.2533 5.03906 11C5.03906 10.7468 5.24435 10.5415 5.49759 10.5415C5.75082 10.5415 5.95611 10.7468 5.95611 11"
      stroke="#323232"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DotsMenu;
